<template>
  <el-tree
    ref="tree"
    :data="treeData"
    :node-key="nodeKey"
    show-checkbox
    expand-on-click-node
    :default-checked-keys="defaultCheckedKeys"
    :default-expand-all="expandAll"
    highlight-current
    :props="defaultProps"
    @check="getKeys"></el-tree>
</template>
<script>
export default {
  name: 'CheckboxTree',
  components: {},
  props: {
    expandAll: {
      type: Boolean,
      default: true
    },
    treeData: {
      type: Array,
      default() {
        return []
      }
    },
    nodeKey: {
      type: String,
      default: 'id'
    },
    value: {
      type: Array,
      default() {
        return []
      }
    },
    defaultProps: {
      type: Object,
      default() {
        return {
          children: 'children',
          label: 'label'
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    defaultCheckedKeys: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    getKeys(data, checked) {
      this.defaultCheckedKeys = checked.checkedKeys
    },
    getCheckedNodes() {
      return this.$refs.tree.getCheckedNodes()
    }
  }
}
</script>
<style lang="stylus"></style>
